/**
 * A text field for entering passwords, with minimal validation.
 */
import {t} from "@lingui/core/macro";
import * as React from "react";

import IdentityTextField from "./identity-text-field.tsx";
import type {IdentityTextFieldProps} from "./types.ts";

type Props = IdentityTextFieldProps & {
    isCreating?: boolean;
};

const PASSWORD_MIN_LENGTH = 8;

const validatePassword = (s: string) => {
    if (s.length < PASSWORD_MIN_LENGTH) {
        return t`Your password must be at least ${PASSWORD_MIN_LENGTH} characters long.`;
    }
    return null;
};

export default (props: Props): React.ReactElement => {
    const {isCreating: _, ...restProps} = props;
    return (
        <IdentityTextField
            label={
                props.isCreating ? t`Create a password` : t`Enter your password`
            }
            emptyMessage={
                props.isCreating
                    ? t`Please create a password.`
                    : t`Please enter your password.`
            }
            notice={
                props.isCreating
                    ? t`Passwords should be at least ${PASSWORD_MIN_LENGTH} characters long and should contain a mixture of letters, numbers, and other characters.`
                    : null
            }
            fieldType="password"
            validator={props.isCreating ? validatePassword : () => null}
            {...restProps}
        />
    );
};
